import initialState from "./overview.value";

const overviewReducer = (state = initialState, action) => {
  switch (action.type) {
    case "Set_Kpi_data":
      return {
        ...state,
        kpis: action.payload,
      };
    case "Set_compare_data":
      return { ...state, compareData: action.payload };
    case "Set_alltrend_data":
      return { ...state, allTrends: action.payload };
    case "Set_byperiod_data":
      return { ...state, byPeriod: action.payload };

    case "Set_graph_model":
      return { ...state, graphModel: action.payload };
    case "Set_graph_obj":
      return { ...state, graphObj: action.payload };



    case "Set_Kpi_data_Hourly":
      return {
        ...state,
        kpis_Hourly: action.payload,
      };
    case "Set_compare_data_Hourly":
      return { ...state, compareData_Hourly: action.payload };
    case "Set_alltrend_data_Hourly":
      return { ...state, allTrends_Hourly: action.payload };
    case "Set_byperiod_data_Hourly":
      return { ...state, byPeriod_Hourly: action.payload };


    default:
      return state;
  }
};

export default overviewReducer;